import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'standard-care-proposal-multiselect-autocomplete',
  template:
    '<multi-autocomplete-list-item [selected]="selected" [item]="item" (changed)="toggle()"> <standard-care-proposal-list-item [item]="item" (clicked)="toggle()"></standard-care-proposal-list-item></multi-autocomplete-list-item>',
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class MulitAutocompleteStandardCareProposalpListItem {
  @Input() item: any;
  @Input() selected: any[];
  @Output() checkedChange: EventEmitter<any> = new EventEmitter<any>();
  toggle() {
    this.checkedChange.emit(this.item);
  }
}
